namespace $ { $mol_style_attach( "bog/builderui/breadcrumbs/breadcrumbs.view.css",
 "[bog_builderui_breadcrumbs] > *:not(:first-child)::before {\n\tcontent: '›';\n\tcolor: var(--bog_builderui_shade);\n\tmargin-right: 0.5rem;\n\tfont-weight: 400;\n\topacity: 0.6;\n}\n"
) }